import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";


export default function AddCourseCard({ onClick }) {
return (
<Card
onClick={onClick}
sx={{
height: "100%",
cursor: "pointer",
display: "flex",
alignItems: "center",
justifyContent: "center",
textAlign: "center",
border: "2px dashed #cfd8dc",
}}
>
<CardContent>
<IconButton color="primary">
<AddIcon fontSize="large" />
</IconButton>
<Typography fontWeight={500}>Add Course</Typography>
</CardContent>
</Card>
);
}